// extracted by mini-css-extract-plugin
export default {"container":"a0z1jkMtO+"};